var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_vm._v(" "+_vm._s(_vm.status_provere)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }